var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),(_vm.words.length)?_c('div',{staticClass:"words-list"},[_c('span',[_vm._v(_vm._s(_vm.prefix))]),_vm._l((_vm.words),function(word,index){return _c('el-button',{key:index,attrs:{"type":"text"},on:{"click":function($event){return _vm.onWordAdd(word)}}},[_vm._v("+"+_vm._s(word))])})],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }